import React from "react";
import { useTranslation } from "react-i18next";

const Services = () => {
  const { t } = useTranslation();

  return (
    <section id="services">
      <h2 style={{ marginTop: 28 }}>{t('services.title')}</h2>
      <div className="services" data-reveal>
        <article className="service">
          <h3>{t('services.consultation.title')}</h3>
          <p className="muted">
            {t('services.consultation.desc')}
          </p>
        </article>

        <article className="service">
          <h3>{t('services.dates.title')}</h3>
          <p className="muted">
            {t('services.dates.desc')}
          </p>
        </article>

        <article className="service">
          <h3>{t('services.match.title')}</h3>
          <p className="muted">
            {t('services.match.desc')}
          </p>
        </article>
      </div>
    </section>
  );
};

export default Services;
